export enum ENUM__ml_asset_generator_unet {
  NORMAL = 'normal',
  INPAINT = 'inpaint',
  DEPTH = 'depth',
}
